module.exports = __webpack_public_path__ + "assets/hotjar.72f19c42.svg";